import axios from 'axios';
import {createAuth} from '../Helpers';
import moment from 'moment';
import {Unit} from "../domain/Unit";
import {UnitBooking} from "../domain/UnitBooking";
import {apiRootUrl, ReducerMethods, TA} from "./configureStore";
import {Reducer} from "redux";

export const reducerName = 'resourceState';

const RESOURCE_GET_ALL_UNITS_REQUEST = 'RESOURCE_GET_ALL_UNITS_REQUEST';
const RESOURCE_GET_ALL_UNITS_RESPONSE = 'RESOURCE_GET_ALL_UNITS_RESPONSE';

const RESOURCE_GET_ALL_BOOKINGS_REQUEST = 'RESOURCE_GET_ALL_BOOKINGS_REQUEST';
const RESOURCE_GET_ALL_BOOKINGS_RESPONSE = 'RESOURCE_GET_ALL_BOOKINGS_RESPONSE';

const RESOURCE_CREATE_BOOKING_REQUEST = 'RESOURCE_CREATE_BOOKING_REQUEST';
const RESOURCE_CREATE_BOOKING_RESPONSE = 'RESOURCE_CREATE_BOOKING_RESPONSE';
const RESOURCE_CREATE_ERROR_DOUBLE_BOOK = 'RESOURCE_CREATE_ERROR_DOUBLE_BOOK';

const RESOURCE_UNIT_OPEN_MENU = 'RESOURCE_UNIT_OPEN_MENU';

const RESOURCE_BOOKING_SHOW_TEAM_MENU = 'RESOURCE_BOOKING_SHOW_TEAM_MENU';
const RESOURCE_BOOKING_SHOW_TIME_MENU = 'RESOURCE_BOOKING_SHOW_TIME_MENU';
const RESOURCE_BOOKING_SET_FIELD = 'RESOURCE_BOOKING_SET_FIELD';

export interface EditUnitBooking{
    unitId: number;
    teamId: number;
    personId?: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export interface ResourceState{
    units: Unit[],
    bookings: UnitBooking[],
    createBooking: EditUnitBooking;
    doubleBook: boolean;
    unitMenuId: boolean;
    showTeamMenu: boolean;
    showTimeMenu: boolean;
    loading:{
        getUnits: boolean;
        getBookings: boolean;
    }
}

const initialState: ResourceState = {
    units: [],
    bookings: [],
    createBooking: {
        unitId: 0,
        teamId: 0,
        personId: undefined,
        startTime: moment(),
        endTime: moment()
    },
    doubleBook: false,
    unitMenuId: false,
    showTeamMenu: false,
    showTimeMenu: false,
    loading: {getUnits: false, getBookings: false}
};

export const actionCreators = {
    setBookingField: (field: string, value: number|string|moment.Moment): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_BOOKING_SET_FIELD, field, value});
    },
    setTeamAndBook: (teamId: number, personId: string): TA => async(dispatch, getState) => {
        const cb = {
            ...getState()[reducerName].createBooking,
            teamId: teamId,
            personId: personId
        };
        dispatch(actionCreators.createBooking(cb.unitId, cb.teamId, cb.personId, cb.startTime, cb.endTime));
    },
    unitMenu: (unitId: string, visible: boolean): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_UNIT_OPEN_MENU, unitId, visible});
    },
    showTeamMenu: (show: boolean): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_BOOKING_SHOW_TEAM_MENU, show});
    },
    showTimeMenu: (show: boolean): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_BOOKING_SHOW_TIME_MENU, show});
    },
    createBooking: (unitId: number, teamId: number, personId: string, startTime: moment.Moment, endTime: moment.Moment): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_CREATE_BOOKING_REQUEST});

        const url = `${apiRootUrl}/api/unitbooking`;
        axios({
            method: 'POST',
            data: {unitId, teamId, personId, startTime: startTime.format('YYYY-MM-DD HH:mm'), endTime: endTime.format('YYYY-MM-DD HH:mm')},
            url: url,
            withCredentials: true,
            auth: createAuth(getState)
        }).then(response => {
            dispatch({type: RESOURCE_CREATE_BOOKING_RESPONSE, data: response.data});
        }).catch(error => {
            console.log(`ERROR(axios): ${RESOURCE_CREATE_BOOKING_REQUEST}`);
            if(error.response.data === 'double_booking'){
                dispatch({type: RESOURCE_CREATE_ERROR_DOUBLE_BOOK});
            }
        });
    },
    getAllUnits: (): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_GET_ALL_UNITS_REQUEST});

        const url = `${apiRootUrl}/api/unit`;
        axios({
            method: 'GET',
            url: url,
            withCredentials: true,
            auth: createAuth(getState),
        }).then(response => {
                dispatch({type: RESOURCE_GET_ALL_UNITS_RESPONSE, data: response.data});
        }).catch(error => {
            //nothing
        });
    },
    //all = 6month before now and 6month after
    getAllBookings: (): TA => async(dispatch, getState) => {
        dispatch({type: RESOURCE_GET_ALL_BOOKINGS_REQUEST});

        const url = `${apiRootUrl}/api/unitbooking`;
        axios({
            method: 'GET',
            url: url,
            withCredentials: true,
            auth: createAuth(getState)
        }).then(response => {
            dispatch({type: RESOURCE_GET_ALL_BOOKINGS_RESPONSE, data: response.data});
        }).catch(error => {

        })
    }
};

const reducerMethods: ReducerMethods<ResourceState> = {
    RESOURCE_BOOKING_SET_FIELD: (state, action) => {
        return{
            ...state,
            createBooking:{
                ...state.createBooking,
                [action.field]: action.value
            }
        }
    },
    RESOURCE_BOOKING_SHOW_TEAM_MENU: (state, action) => {
        return{
            ...state,
            showTeamMenu: action.show
        }
    },
    RESOURCE_BOOKING_SHOW_TIME_MENU: (state, action) => {
        return{
            ...state,
            showTimeMenu: action.show,
            doubleBook: false
        }
    },
    RESOURCE_UNIT_OPEN_MENU: (state, action) => {
        return{
            ...state,
            unitMenuId: action.visible ? action.unitId : false
        }
    },
    RESOURCE_GET_ALL_UNITS_REQUEST: (state, action) => {
        return{
            ...state,
            loading:{
                ...state.loading,
                getUnits: true
            }
        }
    },
    RESOURCE_GET_ALL_UNITS_RESPONSE: (state, action) => {
        return{
            ...state,
            units: action.data,
            loading:{
                ...state.loading,
                getUnits: false
            }
        }
    },
    RESOURCE_GET_ALL_BOOKINGS_REQUEST: (state, action) => {
        return{
            ...state,
            loading:{
                ...state.loading,
                getBookings: true
            }
        }
    },
    RESOURCE_GET_ALL_BOOKINGS_RESPONSE: (state, action) => {
        return{
            ...state,
            bookings: action.data,
            loading:{
                ...state.loading,
                getBookings: false
            }
        }
    },
    RESOURCE_CREATE_BOOKING_REQUEST: (state, action) => {
        return{
            ...state,
            doubleBook: false
        }
    },
    RESOURCE_CREATE_ERROR_DOUBLE_BOOK: (state, action) => {
        return{
            ...state,
            doubleBook: true,
            showTeamMenu: false,
            showTimeMenu: true
        }
    },
    RESOURCE_CREATE_BOOKING_RESPONSE: (state, action) => {
        return{
            ...state,
            showTeamMenu: false,
            unitMenuId: false,
            bookings:[
                ...state.bookings,
                action.data
            ]
        }
    }
};


export const reducer: Reducer<ResourceState> = (state, action) => {
    state = state || initialState;
    const method = reducerMethods[action.type];
    if (method) return method(state, action);
    return state;
};
